export class ExecutionStatusError extends Error {
  name = 'ExecutionStatusError';
}
